module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/redux/~/symbol-observable/index.js
// module id = 2279
// module chunks = 62